import React from "react";

// Article pagination indicators component
export default function ArticleIndicators({ totalPages, currentPage }) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex justify-center mt-8">
      <div className="flex space-x-2">
        {Array.from({ length: totalPages }).map((_, index) => {
          const isActive = currentPage === index;
          return (
            <div
              key={index}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                isActive ? "bg-violet-600" : "bg-gray-600"
              }`}
            />
          );
        })}
      </div>
    </div>
  );
}
